import { Grid, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FullSaleTransactionDataFragment } from '../../../../api';
import Accordion from '../../../../components/Accordion';
import SessionDetailsForm from '../../Forms/SessionDetailsForm';

export type SessionDetailsTabProps = {
    saleTransaction: FullSaleTransactionDataFragment;
};

const SessionDetailsTab = ({ saleTransaction }: SessionDetailsTabProps) => {
    const { t } = useTranslation(['saleTransactionsPage']);
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid spacing={2} container>
            <Grid xs={12} item>
                <Accordion
                    title={t('saleTransactionsPage:accordionTitle.sessionDetails')}
                    useCardDesign={!isSmall}
                    defaultExpanded
                >
                    <SessionDetailsForm saleTransaction={saleTransaction} />
                </Accordion>
            </Grid>
        </Grid>
    );
};

export default SessionDetailsTab;
